// import { useEffect, useState } from "react";
// import { motion } from "framer-motion";
// import axios from "axios";

// const dummyCandidates = {
//   pending: [
//     {
//       id: "C001",
//       name: "John Doe",
//       email: "john@example.com",
//       job: "Frontend Developer",
//     },
//     {
//       id: "C002",
//       name: "Jane Smith",
//       email: "jane@example.com",
//       job: "Backend Developer",
//     },
//   ],
//   ongoing: [
//     {
//       id: "C003",
//       name: "Alice Brown",
//       email: "alice@example.com",
//       job: "Full Stack Developer",
//     },
//   ],
//   completed: [
//     {
//       id: "C004",
//       name: "Bob Martin",
//       email: "bob@example.com",
//       job: "DevOps Engineer",
//       mcqScore: 85,
//       oralScore: 78,
//       codingScore: 92,
//       shortlisted: true,
//     },
//   ],
// };

// const tabs = ["Pending", "Ongoing", "Completed"];

// const HRDashboardPage = () => {
//   const [activeTab, setActiveTab] = useState("Pending");
//   const [search, setSearch] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 5;

//   const data = dummyCandidates[activeTab.toLowerCase()] || [];

//   const filteredData = data.filter(
//     (item) =>
//       item.name.toLowerCase().includes(search.toLowerCase()) ||
//       item.email.toLowerCase().includes(search.toLowerCase()) ||
//       item.id.toLowerCase().includes(search.toLowerCase()) ||
//       item.job.toLowerCase().includes(search.toLowerCase())
//   );

//   const paginatedData = filteredData.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );

//   const handleTabChange = (tab) => {
//     setActiveTab(tab);
//     setSearch("");
//     setCurrentPage(1);
//   };

//   useEffect(() => {
//     getDashboardData()
//   }, [])

//   const getDashboardData = async () => {
//     console.log("sbdjs");
//     try {
//       const payload = {
//         "status": "Completed",
//         "page": 1,
//         "limit": 10
//       }
//       const response = await axios.post(`${process.env.REACT_APP_API_KEY}/get_candidate_by_status`,payload);
//       console.log(response.data,"***response***");

//     } catch (error) {

//     }
//   };

//   return (
//     <div className="p-6 bg-gray-100 min-h-screen">
//       <h1 className="text-3xl font-bold text-blue-800 mb-6">HR Dashboard</h1>

//       {/* Tabs */}
//       <div className="flex gap-4 mb-4">
//         {tabs.map((tab) => (
//           <button key={tab} onClick={() => handleTabChange(tab)}>
//             {tab}
//           </button>
//         ))}
//       </div>

//       {/* Filter */}
//       <div className="mb-4">
//         <input
//           type="text"
//           placeholder="Search candidates..."
//           className="w-full p-2 border border-gray-300 rounded"
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//         />
//       </div>

//       {/* Table */}
//       <div className="bg-white shadow-lg rounded-lg overflow-hidden">
//         <table className="w-full table-auto">
//           <thead className="bg-blue-700 text-white">
//             <tr>
//               <th className="p-3 text-left">Candidate ID</th>
//               <th className="p-3 text-left">Name</th>
//               <th className="p-3 text-left">Email</th>
//               <th className="p-3 text-left">Job</th>
//               {activeTab === "Completed" && (
//                 <>
//                   <th className="p-3 text-left">MCQ</th>
//                   <th className="p-3 text-left">Oral</th>
//                   <th className="p-3 text-left">Coding</th>
//                   <th className="p-3 text-left">Shortlisted</th>
//                   <th className="p-3 text-left">Report</th>
//                 </>
//               )}
//             </tr>
//           </thead>
//           <tbody>
//             {paginatedData.length > 0 ? (
//               paginatedData.map((cand) => (
//                 <tr key={cand.id} className="border-b hover:bg-gray-100">
//                   <td className="p-3">{cand.id}</td>
//                   <td className="p-3">{cand.name}</td>
//                   <td className="p-3">{cand.email}</td>
//                   <td className="p-3">{cand.job}</td>
//                   {activeTab === "Completed" && (
//                     <>
//                       <td className="p-3">{cand.mcqScore}</td>
//                       <td className="p-3">{cand.oralScore}</td>
//                       <td className="p-3">{cand.codingScore}</td>
//                       <td className="p-3">{cand.shortlisted ? "Yes" : "No"}</td>
//                       <td className="p-3">
//                         <motion.button
//                           whileHover={{ scale: 1.05 }}
//                           whileTap={{ scale: 0.95 }}
//                           onClick={() =>
//                             alert(`Redirecting to report for ${cand.name}`)
//                           }
//                           className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700"
//                         >
//                           View Report
//                         </motion.button>
//                       </td>
//                     </>
//                   )}
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td
//                   colSpan={activeTab === "Completed" ? 9 : 4}
//                   className="p-4 text-center text-gray-500"
//                 >
//                   No candidates found.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       <div className="flex justify-between items-center mt-4">
//         <span className="text-gray-600">
//           Page {currentPage} of {Math.ceil(filteredData.length / itemsPerPage)}
//         </span>
//         <div className="flex gap-2">
//           <button
//             onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//             className="px-3 py-1 border border-gray-300 rounded hover:bg-gray-200"
//             disabled={currentPage === 1}
//           >
//             Previous
//           </button>
//           <button
//             onClick={() =>
//               setCurrentPage((prev) =>
//                 prev < Math.ceil(filteredData.length / itemsPerPage)
//                   ? prev + 1
//                   : prev
//               )
//             }
//             className="px-3 py-1 border border-gray-300 rounded hover:bg-gray-200"
//             disabled={
//               currentPage >= Math.ceil(filteredData.length / itemsPerPage)
//             }
//           >
//             Next
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HRDashboardPage;
import { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";

function HRDashboard() {
  const [candidates, setCandidates] = useState([]);
  const [activeTab, setActiveTab] = useState("Pending");
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [filter, setFilter] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchCandidates = async (status) => {
    setLoading(true);
    try {
      const payload = {
        status,
        page: pagination.page,
        limit: pagination.limit,
      };
      const response = await axios.post(
        `${process.env.REACT_APP_API_KEY}/get_candidate_by_status?filter=${filter?filter:""}`,
        payload
      );
      setCandidates(response.data.candidates);
    } catch (error) {
      console.error("Fetch error:", error);
      toast.error("Failed to fetch candidates");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCandidates(activeTab);
  }, [activeTab, pagination.page, filter]);

  const handleTabClick = (status) => {
    setActiveTab(status);
    setPagination({ ...pagination, page: 1 }); // Reset to first page on tab change
  };

  const handleFilterChange = (e) => {
    setFilter(e.target.value);
    setPagination({ ...pagination, page: 1 }); // Reset to first page on filter change
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0) {
      setPagination((prev) => ({ ...prev, page: newPage }));
    }
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold mb-6">HR Dashboard</h1>

      {/* Tabs */}
      <div className="flex space-x-4 mb-4">
        {["Pending", "Ongoing", "Completed"].map((status) => (
          <button
            key={status}
            onClick={() => handleTabClick(status)}
            className={`px-4 py-2 rounded-lg font-semibold ${
              activeTab === status
                ? "bg-blue-600 text-white"
                : "bg-white border border-gray-300 text-gray-700"
            }`}
          >
            {status}
          </button>
        ))}
      </div>

      {/* Filter Input */}
      <div className="mb-4">
        <input
          type="text"
          placeholder="Filter by name or email"
          value={filter}
          onChange={handleFilterChange}
          className="w-full max-w-md px-4 py-2 border border-gray-300 rounded-lg"
        />
      </div>

      {/* Candidates Table */}
      <div className="bg-white shadow rounded-lg p-4">
        {loading ? (
          <p className="text-gray-500">Loading candidates...</p>
        ) : candidates.length === 0 ? (
          <p className="text-gray-500">No candidates found.</p>
        ) : (
          <table className="w-full table-auto">
            <thead>
              <tr className="text-left border-b">
                <th className="px-4 py-2">ID</th>
                <th className="px-4 py-2">Name</th>
                <th className="px-4 py-2">Email</th>
                <th className="px-4 py-2">Job</th>
                {activeTab === "Completed" && (
                  <>
                    <th className="px-4 py-2">MCQ</th>
                    <th className="px-4 py-2">Q&A</th>
                    <th className="px-4 py-2">Shortlisted</th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {candidates.map((candidate) => (
                <tr key={candidate["Candidate ID"]} className="border-b">
                  <td className="px-4 py-2">{candidate["Candidate ID"]}</td>
                  <td className="px-4 py-2">{candidate["Name"]}</td>
                  <td className="px-4 py-2">{candidate["Email"]}</td>
                  <td className="px-4 py-2">{candidate["Job"]}</td>
                  {activeTab === "Completed" && (
                    <>
                      <td className="px-4 py-2">{candidate["MCQ"] ?? "-"}</td>
                      <td className="px-4 py-2">
                        {candidate["Question Answer"] ?? "-"}
                      </td>
                      <td className="px-4 py-2">
                        {candidate["Shortlisted"] ?? "-"}
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Pagination Controls */}
      <div className="flex justify-between items-center mt-6">
        <button
          onClick={() => handlePageChange(pagination.page - 1)}
          disabled={pagination.page === 1}
          className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
        >
          Previous
        </button>
        <span>
          Page <strong>{pagination.page}</strong>
        </span>
        <button
          onClick={() => handlePageChange(pagination.page + 1)}
          className="px-4 py-2 bg-gray-200 rounded"
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default HRDashboard;
